<template>
    <el-input v-model="modelValue" :placeholder="'请输入'+column.label" clearable @keydown.enter.stop="$emit('search',modelValue)">
        <template #suffix>
            <el-icon class="el-input__icon" @click.stop="$emit('search',modelValue)">
                <el-icon-search/>
            </el-icon>
        </template>
    </el-input>
</template>


<script setup>
defineOptions({
    name: 'TextFilter'
})
const props = defineProps({
    column: {
        type: Object,
        default: () => ({})
    },
})
const modelValue = defineModel({local: true, default: '', type: String})
</script>
<style>

</style>